<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card card-height">
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div class="col-12 col-sm-6 col-md-3">
              <label class="form-label">Employee <span class="required">*</span></label>
              <AsyncSelect
                  placeholder="Select Employee"
                  v-model="contactProfile"
                  :api-service="fetchContactProfiles"
                  :additional-query="additionalContactOption"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <div class="mb-2 row">
                <label class="align-middle">Letter Template <span class="required">*</span></label>
                <AsyncSelect
                    placeholder="Select Letter Template"
                    v-model="letterTemplate"
                    :api-service="fetchLetterTemplateDropdown"
                />
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <div class="mb-2 row">
                <label class="align-middle">Select Purpose</label>
                <v-select
                    placeholder="Select Purpose"
                    v-model="formData.purpose_note_master_id"
                    :options="letterTypePurposeList"
                    label="name"
                    :reduce="name => name.id"
                />
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <label class="form-label">HR/Employer <span class="required">*</span></label>
              <AsyncSelect
                  placeholder="Select Employee"
                  v-model="employerContactProfile"
                  :api-service="fetchContactProfiles"
                  :additional-query="additionalContactOption"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <label class="form-label">Issue Date <span class="required">*</span></label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.issue_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <label class="form-label">Effective Date <span class="required">*</span></label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.effective_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <label class="form-label">From Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.from_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <label class="form-label">To Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.to_date"
              >
            </div>

            <div class="col-12 mt-2">
              <TipTapEditor
                  :content="formData.value"
                  @update:content="val => formData.value = val"
                  ref="editorRefs"
                  :ref-for="true"
              />
            </div>

            <div v-if="!isCreate" class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="align-middle">Status</label>
              <v-select
                  placeholder="Select Policy"
                  v-model="formData.status"
                  :options="status"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
              class="btn btn-primary">
        Save
      </button>
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
              class="btn btn-primary">Save & New
      </button>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, nextTick, onMounted, ref, watch} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useStore} from "vuex";
import handleContact from "@/services/modules/contact";
import handleHospital from '@/services/modules/hospital'
import handleDropDown from "@/services/modules/dropdowns";
import TipTapEditor from '@/components/atom/TipTapEditor'

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let headerTitle = ref("Add Letter")
let letterTypePurposeList = ref([])
let letterEditData = ref({})
const status = ref([]);
const additionalContactOption = ref({
  roles: 'employee',
  status: 'active'
});
let contactProfile = ref(null)
let letterTemplate = ref(null)
let employerContactProfile = ref(null)
const isInitializing = ref(false)
let letterData = {}
let formData = ref({
  company_id: companyId,
  status: 'active',
  contact_profile_id:'',
  purpose_note_master_id:'',
  employer_contact_profile_id:'',
  message_template_master_id:'',
  issue_date:'',
  effective_date:'',
  from_date:'',
  to_date:'',
  value:'',
})

function navigateToListPage() {
  delete route.query.letterId;
  router.push({name: `letters`, params: route.params, query: route.query});
}

const {
  createLetter,
  fetchSingleLetter,
  updateLetter,
  getLetterTemplatePreview,
  fetchTypes,
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact();
const { fetchNoteMasterList } = handleHospital();
const { fetchLetterTemplateDropdown } = handleDropDown();

function saveAP(redirect = true) {
  if (isCreate.value) {
    handleSubmit(redirect);
  } else {
    handleUpdate(redirect);
  }
}

watch([contactProfile, letterTemplate], ([contact, template]) => {
  if (isInitializing.value) return
  if (contact && template) {
    fetchLetterPreviewData()
  }
})

const fetchLetterPreviewData = async () => {
  saveButtonLoader.value = true
  let query = `?company_id=${route.params.companyId}`;
  query += '&contact_profile_id=' + contactProfile.value.id;
  query += '&message_template_master_id=' + letterTemplate.value.id;

  await getLetterTemplatePreview(query).then(res => {
    if (!res.status){
      return
    }
    formData.value.value = res.data.formatted_letter;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    saveButtonLoader.value = false
  })
}
function handleSubmit(redirect) {
  letterData.company_id  = formData.value.company_id;
  letterData.status = "active";
  letterData.contact_profile_id = contactProfile.value ? contactProfile.value.id : null;
  letterData.message_template_master_id = letterTemplate.value ? letterTemplate.value.id : null;
  letterData.employer_contact_profile_id = employerContactProfile.value ? employerContactProfile.value.id : null;
  letterData.purpose_note_master_id = formData.value.purpose_note_master_id;
  letterData.issue_date = formData.value.issue_date;
  letterData.effective_date = formData.value.effective_date;
  letterData.from_date = formData.value.from_date;
  letterData.to_date = formData.value.to_date;
  letterData.value = formData.value.value;
  createAP(redirect);
}

function handleUpdate(redirect) {
  letterData.id = formData.value.id;
  letterData.status = formData.value.status;
  letterData.contact_profile_id = contactProfile.value ? contactProfile.value.id : null;
  letterData.message_template_master_id = letterTemplate.value ? letterTemplate.value.id : null;
  letterData.employer_contact_profile_id = employerContactProfile.value ? employerContactProfile.value.id : null;
  letterData.purpose_note_master_id = formData.value.purpose_note_master_id;
  letterData.issue_date = formData.value.issue_date;
  letterData.effective_date = formData.value.effective_date;
  letterData.from_date = formData.value.from_date;
  letterData.to_date = formData.value.to_date;
  letterData.value = formData.value.value;
  updateAPData(redirect);
}

function createAP(redirect = true) {
  createLetter(letterData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message)
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function updateAPData(redirect = true) {
  updateLetter(letterData, letterData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  headerTitle.value = "Update Letter";
  formData.value.id =  letterEditData.value.id;
  contactProfile.value = {
    id: letterEditData.value.contact_profile_id,
    name: letterEditData.value.employee_name
  }
  letterTemplate.value = {
    id: letterEditData.value.message_template_master_id,
    name: letterEditData.value.template_name
  }
  employerContactProfile.value = {
    id: letterEditData.value.employer_contact_profile_id,
    name: letterEditData.value.employer_name
  }
  formData.value.purpose_note_master_id = letterEditData.value.purpose_note_master_id;
  formData.value.issue_date = letterEditData.value.issue_date;
  formData.value.effective_date = letterEditData.value.effective_date;
  formData.value.from_date = letterEditData.value.from_date;
  formData.value.to_date = letterEditData.value.to_date;
  formData.value.value = letterEditData.value.value;
  formData.value.status = letterEditData.value.status;

  nextTick(() => {
    isInitializing.value = false
  })
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      status.value = [];
      return
    }

    if (res.data && res.data.status) {
      status.value = res.data.status;
    }

  }).catch(err => {
    console.log(err)
  })
}

function onPageReload() {
  loader.value=true
  let query = getQuery()
  let noteMasterQuery = query + '&is_all=true&status=active&note_type=letter_type_purpose'

  Promise.all([
    getTypes(),
    fetchNoteMasterList(noteMasterQuery).then(res => {
      if (res.data) {
        letterTypePurposeList.value = res.data
      }
    })
  ]).finally(() => {
    loader.value = false
  })

  formData.value.issue_date =  new Date().toISOString().split('T')[0]
  if(route.query.letterId && route.query.letterId !== '' && route.query.letterId !== undefined){
    isCreate.value = false;
    isInitializing.value = true
    const fetchData = fetchSingleLetter(route.query.letterId, getQuery());
    fetchData.then(res2 => {
      letterEditData.value = res2.data;
      setFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
})
</script>